/* eslint-disable react-hooks/exhaustive-deps */
import { Paper, Box, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Typography, IconButton, useMediaQuery,} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useMemo, useState } from "react"
import qs from 'qs'
import { ListagemItem } from "src/components/projetos/types"
import { Layout } from "../../_layouts"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { apiNoLoading } from "src/framework/providers/api"
import { setPersonalizadoTabDisabledStatus, setPersonalizadoTabDoneStatus } from "src/store/vendas/projetos/actions"
import theme from "src/theme/light"
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants"
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert"
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants"
import { FindInPageOutlined } from "@mui/icons-material"
import AcessoriosListMobile from "src/components/projetos/containers/Mobile/AcessoriosListMobile"
import { Componente, ID_ACESSORIO, ID_BATERIA, ID_CABO, ID_CONECTOR, ID_INVERSOR_ONDA_SENOIDAL, ID_MEDIDOR, ID_MONITORAMENTO, ID_RSD, ID_STRING_BOX, ID_TRANSFORMADOR_CORRENTE } from "src/components/componentes/types";
import { useProjetoPersonalizadoOffgridStore } from "src/store/vendas/projetos/personalizado_offgrid/personalizadoOffgrid.store";
import { useObservable } from "src/framework/store/storeUtil";
import { fraseParceiro$ } from "src/store/global.store";

interface AcessoriosProps {
  onClickBack: () => void
  onClickNext: () => void
}

const useStyles = makeStyles({
  tableHeaderRow: {
    cursor: 'pointer'
  },
  warningText: {
    color: theme.palette.warning.main
  }
})

const Acessorios = ({ onClickBack, onClickNext }: AcessoriosProps) => {
  const classes = useStyles()
  const projetoState = useProjetoPersonalizadoOffgridStore(store => store.state.data);
  const { changeValue, changeModal } = useProjetoPersonalizadoOffgridStore(store => store.actions);
  const [acessorios, setAcessorios] = useState<ListagemItem[]>(projetoState.acessorios || [])
  const [fraseParceiroExibidoList] = useState<number[]>([]);
  const [loading, setLoading] = useState(false)

  const fraseParceiroPowerAlert = useObservable(fraseParceiro$);
  
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getOrdemCategoria = (categoriaId: number) => {
    switch (categoriaId) {
      case ID_BATERIA:
        return 1;
      case ID_INVERSOR_ONDA_SENOIDAL:
        return 2;
      case ID_STRING_BOX:
        return 3;
      case ID_CONECTOR:
        return 4;
      case ID_CABO:
        return 5;
      case ID_ACESSORIO:
        return 6;
      case ID_MEDIDOR:
        return 7;
      case ID_TRANSFORMADOR_CORRENTE:
        return 8;
      case ID_MONITORAMENTO:
        return 9;
      case ID_RSD:
        return 10;
      default:
        return 11;
    }
  };

  useEffect(()=>{
    setLoading(true)
    apiNoLoading.get({
      url: '/estoque/categorias_componentes?grupo=acessorios'
    }).then(res => {
      const acessoriosId = (res?.data?.map((item: any) => item.id) || []);
      const categorias = [...acessoriosId, ID_INVERSOR_ONDA_SENOIDAL, ID_BATERIA];
      if (categorias.length) {
        const queryString = qs.stringify({
          categoria_componentes_id: categorias.join(','),
          regiao_id: projetoState.regioes.length ? projetoState.regioes.map(item => item.id).join(',') : undefined,
          segmento: "off",
          tipo_solucao: projetoState.tipo_solucao?.value || null,
        })

        apiNoLoading.get({
          url: `/estoque/componentes/categorias?${queryString}`
        }).then(res => {
          const items = (res?.data || []).sort(
            (a: Componente, b: Componente) =>
              getOrdemCategoria(Number(a.categoria_componentes_id)) -
              getOrdemCategoria(Number(b.categoria_componentes_id))
          );

          const newAcessorios = items.map((item: Componente): ListagemItem => {
            const savedItem = (projetoState.acessorios || []).find(acessorio => acessorio.componente_id === item.id)
            return {
              componente_id: Number(item.id),
              nome: item.nome || '',
              descricao: item.descricao || '',
              quantidade: savedItem?.quantidade || 0,
              altura: Number(item.altura || 0),
              categoria_componentes_id: Number(item.categoria_componentes_id || 0),
              largura: Number(item.largura || 0),
              peso: Number(item.peso || 0),
              potencia: 0,
              valor: 0,
              valor_unitario: savedItem?.valor_unitario || 0,
              exibir_popup_parceiro: item.exibir_popup_parceiro || false,
            }
          })
          setAcessorios(newAcessorios)
        }).finally(() => setLoading(false))
      }
    })
  },[])

  const handleChangeItemQuantity = useCallback((acessorioId: number, value: any) => {
    const newAcessorios = acessorios.map(acessorio => {
      if (acessorio.componente_id === acessorioId) {
        if (acessorio.exibir_popup_parceiro ) {
          const idx = fraseParceiroExibidoList.findIndex(c => c === acessorioId);
          if (idx < 0 && value > 0) {
            showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
            fraseParceiroExibidoList.push(acessorioId);
          } else {
            if (value === 0) {
              fraseParceiroExibidoList.splice(idx, 1);
            }
          }
        }
        return {
          ...acessorio,
          quantidade: value,
        }
      }
      return acessorio
    })
    changeValue({ acessorios: newAcessorios })
    setAcessorios(newAcessorios)
  }, [projetoState, acessorios, changeValue])

  const checkError = useCallback((categoriaIds: number, qtd: number): boolean => {
    if (categoriaIds !== ID_CABO) return false;
    if (qtd === 0) return false;
    if (qtd % 25 === 0) return false;
    return true
  },[])

  const nextButtonIsDisabled = useMemo(()=>{
    const cabos = acessorios.filter(item => item.categoria_componentes_id === ID_CABO)
    if (cabos.some(cabo => checkError(cabo.categoria_componentes_id, Number(cabo.quantidade)))) return true
    return false
  },[acessorios, checkError])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('finalizacao', nextButtonIsDisabled)
    setPersonalizadoTabDoneStatus('acessorios', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  const renderAcessorios = useCallback(() => {

    if (loading) {
      return (
        <div>Buscando acessórios...</div>
      )
    }

    if (isMobile) {
      return <AcessoriosListMobile 
        acessorios={acessorios}
        handleChangeQuantity={handleChangeItemQuantity}
        checkError={checkError}
        handleOpenModalDadosTecnicos={changeModal}
      />
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell align='left'><strong>Acessórios disponíveis</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {acessorios.map(acessorio => (
              <TableRow key={acessorio.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Box textAlign={'left'}>
                      <Typography variant='body1' color='textPrimary'>
                        <strong>{acessorio.nome}</strong>
                      </Typography>
                      <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}><strong>Informações:</strong></span> {acessorio.descricao}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  <Box width="180px" margin={"0 auto"}>
                    <InputQuantidade hasError={checkError(acessorio.categoria_componentes_id, acessorio.quantidade)} multiple={acessorio.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1} value={acessorio.quantidade} onChange={(v: any) => handleChangeItemQuantity(acessorio.componente_id, v)} />
                    {acessorio.categoria_componentes_id === ID_CABO && checkError(acessorio.categoria_componentes_id, acessorio.quantidade) && (
                      <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                    )}
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton size="large" onClick={() => acessorio.componente_id && changeModal({ detalhesComponenteId: acessorio.componente_id })}>
                      <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [loading, classes.tableHeaderRow, classes.warningText, acessorios, checkError, handleChangeItemQuantity])

  return (
    <Layout
      nextButtonIsDisabled={nextButtonIsDisabled}
      title="Acessórios"
      subtitle="Para que seu projeto fique completo, escolha os acessórios que atenderão a demanda do seu cliente." onClickBack={onClickBack} onClickNext={onClickNext}
    >
      <Box p={2}>
        {renderAcessorios()}
      </Box>
    </Layout>
  )
}

export { Acessorios }
